module.exports = __webpack_public_path__ + "static/media/Avatars_Female-03.000f4434.png";